import axios from 'axios';
import { FETCHING_LINEINFORMATION, FETCH_LINEINFORMATION_SUCCESS } from "./LineDataInformationConstants";

const path = 'utm/v1/transactions/status';

const fetchingLineDataInformation = () => ({ type: FETCHING_LINEINFORMATION });
const fetchLineDataInformationSuccess = lineDataInformation => ({ type: FETCH_LINEINFORMATION_SUCCESS, lineDataInformation });

export const fetchLineDataInformation = (periodId) => dispatch => {
  dispatch(fetchingLineDataInformation());
  axios.get(`${path}/?periodId=${periodId}`)
    .then(response => {
      dispatch(fetchLineDataInformationSuccess(response.data.data));
    })
    .catch(error => { throw error; });
};




// WEBPACK FOOTER //
// ./src/redux/lineDataInformation/LineDataInformationActions.js